/**
 * PWAContext — single source of truth for all PWA state.
 *
 * Wraps usePWA() once at the app root so that AppLayout, PWABanners,
 * and any other consumer share ONE set of event listeners and ONE
 * install-prompt capture (the beforeinstallprompt fires only once).
 */
import { createContext, useContext } from 'react';
import { usePWA } from '../hooks/usePWA.js';

const PWAContext = createContext(null);

export function PWAProvider({ children }) {
  const pwa = usePWA();
  return <PWAContext.Provider value={pwa}>{children}</PWAContext.Provider>;
}

/** Use anywhere inside PWAProvider */
export function usePWAContext() {
  const ctx = useContext(PWAContext);
  if (!ctx) throw new Error('usePWAContext must be used inside <PWAProvider>');
  return ctx;
}
